export default {
  ALLOW_ROUTE_REDIRECTION: process.env.REACT_APP_ALLOW_ROUTE_REDIRECTION === 'true',
};
